export const UTILITY_TYPES = {
  ELECTRIC_ENERGY: 'ee' as Utils.IUtilityType,
  NATURAL_GAS: 'gn' as Utils.IUtilityType
};
